module.exports = __webpack_public_path__ + "static/media/保腎護心網layout物件_54.4a6ceef5.png";